import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=b6aa0f72"
import script from "./file-input.vue?vue&type=script&lang=js"
export * from "./file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports